import { useInfiniteQuery } from '@tanstack/react-query';

import { ARTICLES_PER_PAGE } from '@/modules/blog/constants';
import { blogArticlesInfiniteQueryOptions } from '@/modules/blog/queries';

export function useBlogArticles() {
  const query = useInfiniteQuery(
    blogArticlesInfiniteQueryOptions(ARTICLES_PER_PAGE)
  );

  const pages = query?.data?.pages || [];
  const latestPageArticles = pages[pages.length - 1] || [];
  const isEnd =
    latestPageArticles.length === 0 ||
    latestPageArticles.length < ARTICLES_PER_PAGE;

  return { ...query, isEnd };
}
